import { render, staticRenderFns } from "./RealTimeStatistics.vue?vue&type=template&id=365a1166&scoped=true&"
import script from "./RealTimeStatistics.vue?vue&type=script&lang=ts&"
export * from "./RealTimeStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./RealTimeStatistics.vue?vue&type=style&index=0&id=365a1166&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a1166",
  null
  
)

export default component.exports